import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverHighlight, hoverOpacity } from '@/utility/theme/animation';

export const HeldDate = styled.h2(() =>
  mq({
    fontSize: defaultTheme.font.size.m,
    fontWeight: 'bold',
    marginBottom: defaultTheme.spacing.xxl,
  }),
);

export const RaceProgramInfoWrapper = styled.div(() =>
  mq({
    width: '100%',
    display: ['block', 'block', 'flex'],
  }),
);

export const RaceCardWrapper = styled.div(
  mq({
    marginTop: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
    ],
    display: 'grid',
    gridTemplateColumns: [
      'repeat(1, 1fr)',
      'repeat(1, 1fr)',
      'repeat(2, 1fr)',
      'repeat(3, 1fr)',
    ],
    gridGap: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
    ],
    width: '100%',
  }),
);

export const RaceCardContent = styled.div(
  mq({
    backgroundColor: defaultTheme.background.white,
    padding: [
      defaultTheme.spacing.l,
      defaultTheme.spacing.l,
      defaultTheme.spacing.xxl,
    ],
  }),
);

export const RaceCardHeader = styled.div(
  mq({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: defaultTheme.spacing.l,
  }),
);

export const RaceCardInfoWrapper = styled.div(
  mq({
    height: '40px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  }),
);

export const TimeWrapper = styled.div(() =>
  mq({
    display: 'flex',
  }),
);

export const Time = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    marginRight: defaultTheme.spacing.s,
    time: {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const ButtonWrapper = styled.div(
  mq({
    marginTop: defaultTheme.spacing.l,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gridGap: `${defaultTheme.spacing.s}`,
  }),
);

const BaseButton = styled.span(() =>
  mq({
    padding: `${defaultTheme.spacing.m}`,
    color: defaultTheme.color.secondary,
    fontSize: defaultTheme.font.size.s,
    textAlign: 'center',
    border: `1px solid ${defaultTheme.color.secondary}`,
    borderRadius: defaultTheme.border.radius.s,
  }),
);

export const BlackButtonLink = styled(BaseButton)(() =>
  mq({
    ...hoverOpacity,
  }),
).withComponent(Link);

export const DisabledButton = styled(BaseButton)(() =>
  mq({
    opacity: defaultTheme.button.opacity.disabled,
  }),
);

export const BackLinkArea = styled.div(() =>
  mq({
    width: '100%',
    textAlign: 'center',
    marginTop: defaultTheme.spacing.s,
  }),
);

export const BackLink = styled(Link)(() =>
  mq({
    display: 'inline-block',
    fontSize: defaultTheme.font.size.s,
    ...hoverHighlight,
  }),
);

export const NoRaceText = styled.p(() =>
  mq({
    width: '100%',
    padding: '88px 0',
    backgroundColor: defaultTheme.background.white,
    color: defaultTheme.color.grayScale.dark,
    fontSize: defaultTheme.font.size.m,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: [
      defaultTheme.spacing.s,
      defaultTheme.spacing.s,
      defaultTheme.spacing.l,
    ],
  }),
);
